import React, { useEffect, useRef, useState } from "react";

/**
 * Zählt eine Zahl von 0 hoch, sobald sie in den sichtbaren Bereich scrollt.
 * value: z.B. "10+", "★ 4.9", "100%", "24/7" - der numerische Teil wird erkannt und hochgezählt,
 * Präfix/Suffix (★, +, %, /7 etc.) bleiben dabei unverändert stehen.
 */
export function CountUp({ value, duration = 1400, className = "" }) {
  const ref = useRef(null);
  const [display, setDisplay] = useState(null);
  const started = useRef(false);

  const match = String(value).match(/(-?\d+(\.\d+)?)/);
  const target = match ? parseFloat(match[1]) : null;
  const prefix = match ? String(value).slice(0, match.index) : "";
  const suffix = match ? String(value).slice(match.index + match[0].length) : "";
  const decimals = match && match[1].includes(".") ? match[1].split(".")[1].length : 0;

  useEffect(() => {
    const el = ref.current;
    if (!el || target === null || typeof IntersectionObserver === "undefined") {
      setDisplay(target !== null ? target : null);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (now) => {
            const progress = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - progress, 3);
            setDisplay(target * eased);
            if (progress < 1) requestAnimationFrame(tick);
            else setDisplay(target);
          };
          requestAnimationFrame(tick);
          observer.unobserve(el);
        }
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [target, duration]);

  if (target === null) return <span ref={ref} className={className}>{value}</span>;

  return (
    <span ref={ref} className={className}>
      {prefix}{(display ?? 0).toFixed(decimals)}{suffix}
    </span>
  );
}
